import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {AndroidModel, Android} from './../../models/android.model';

@Component({
  selector: 'app-modal-android',
  templateUrl: './modal-android.component.html',
  styles: []
})
export class ModalAndroidComponent implements OnInit {

  formControl = new FormControl('');
  modalForm : FormGroup;
  android: Android;
  private _androidModel = new AndroidModel ;
  selectedFile : File;
  message: string;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.android ? this.android.clave : null],
      nombre: [this.android ? this.android.nombre : null],
      url: [this.android ? this.android.url : null],
      alias: [this.android ? this.android.alias : null],
      keystorePassword: [this.android ? this.android.keystorePassword : null],
      keyPassword: [this.android ? this.android.keyPassword : null],
    });
  }

  onFileSelected(event){
    this.selectedFile = event.target.files[0];
  }

  //Agregar dominio
  adminAndroidKey(){
    this.activeModal.close('Guardado datos');
    if(this.selectedFile)
    {
      this._androidModel.uploadImageProfile(this.selectedFile, '/android/', this.selectedFile.name).then(val => {
        var ruta = val;
        this._androidModel.createAndroid(this.modalForm.value, ruta);
      });
    }
    else
    {
      this._androidModel.createAndroid(this.modalForm.value, "");
    }
  }

}
